<template>
    <div class="flex-row mt-5 animated fadeIn">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col sm="9" md="7" lg="5" xl="4">
                    <b-card-group>
                        <b-card no-body class="p-3">
                            <b-card-body class="pb-0">
                                <div class="text-center">
                                    <img
                                        src="img/logo-login.png"
                                        class="rounded mb-4"
                                        alt="app-logo"
                                    />
                                    <br />
                                    <h2>{{ appNome }}</h2>
                                    <span>{{ appDescr }}</span>
                                    <br />
                                    <br />
                                </div>
                                <p class="text-muted">
                                    Entre com suas credenciais
                                </p>
                                <app-erros-box
                                    :erros="erros"
                                    v-if="erros.length > 0"
                                ></app-erros-box>
                                <b-form>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text>
                                                <i class="icon-user"></i>
                                            </b-input-group-text>
                                        </b-input-group-prepend>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Usuário"
                                            v-model="login.usuario"
                                            autocomplete="username"
                                        />
                                    </b-input-group>
                                    <b-input-group class="mb-4">
                                        <b-input-group-prepend>
                                            <b-input-group-text>
                                                <i class="icon-lock"></i>
                                            </b-input-group-text>
                                        </b-input-group-prepend>
                                        <input
                                            type="password"
                                            class="form-control"
                                            placeholder="Senha"
                                            v-model="login.senha"
                                            autocomplete="current-password"
                                        />
                                    </b-input-group>
                                    <div class="d-flex justify-content-center">
                                        <vue-recaptcha
                                            ref="recaptcha"
                                            @verify="onCaptchaVerified"
                                            @expired="onCaptchaExpired"
                                            :sitekey="recaptchaSiteToken"
                                            :loadRecaptchaScript="true"
                                            language="pt-BR"
                                            v-if="recaptchaSiteToken"
                                        ></vue-recaptcha>
                                    </div>
                                </b-form>
                                <!-- <b-row>
									<b-col cols="6">
										<b-button variant="primary" class="px-4" @click="verificarRecaptcha()">Entrar</b-button>
									</b-col>
                                </b-row>-->
                                <b-row>
                                    <b-col>
                                        <div class="mt-4 text-center">
                                            <span>
                                                <strong>v{{ versao }}</strong>
                                            </span>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import LoginServicos from './LoginServicos'
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'

export default {
    name: 'Login',
    components: {
        'vue-recaptcha': VueRecaptcha
    },

    data() {
        return {
            login: {
                usuario: '',
                senha: ''
            },
            erros: [],
            versao: '',
            recaptchaSiteToken: null,
            recaptchaToken: '',
            appNome: 'GESCON',
            appDescr: 'Gestão de Contratos e Convênios'
        }
    },

    created() {
        axios.get('app/versao.txt').then((res) => {
            this.versao = res.data
        })
    },

    beforeCreate() {
        axios.get('app/recaptcha.txt').then((res) => {
            this.recaptchaSiteToken = res.data
        })
    },

    methods: {
        // verificarRecaptcha() {
        // 	this.$refs.recaptcha.execute()
        // },

        onCaptchaVerified(recaptchaToken) {
            this.recaptchaToken = recaptchaToken
            this.entrar()
        },

        onCaptchaExpired() {
            this.$refs.recaptcha.reset()
        },

        entrar() {
            this.$store.dispatch('addRequest')
            let loginDto = {
                usuario: this.login.usuario.toLowerCase(),
                senha: btoa(this.login.senha),
                recaptchaToken: this.recaptchaToken
            }
            LoginServicos.login(loginDto).then((data) => {
                if (data) {
                    if (data.success) {
                        this.$store.dispatch('login', data.data)
                        this.processarRota()
                    } else {
                        this.erros = data.errors
                    }
                }
                this.$store.dispatch('removeRequest')
                this.$refs.recaptcha.reset()
            })
        },

        processarRota() {
            if (this.$store.getters.usuario.asplFlag === 'True') {
                this.$router.push('/atualizarsenha')
            } else {
                if (this.$route.query.redirect) {
                    let redirect = this.$route.query.redirect
                    delete this.$route.query.redirect
                    this.$router.push({
                        path: redirect,
                        query: this.$route.query
                    })
                } else {
                    this.$router.push('/')
                }
            }
        },

        processarRotaQuery() {
            if (this.$route.query.a) {
                if (this.$route.query.a == 'FinalizarAvisoVencimentoContrato') {
                    this.$router.push({
                        path: '/processos/finalizaravisovencimentocontrato',
                        query: {
                            c: this.$route.query.c,
                            v: this.$route.query.v
                        }
                    })
                } else {
                    this.$router.push('/')
                }
            } else {
                this.$router.push('/')
            }
        }
    }
}
</script>
